import React, { Component } from 'react'
import { Link } from 'react-router'
import {
  Paper,
  Dialog,
  MenuItem,
  TextField,
  DatePicker,
  TimePicker,
  FlatButton,
  SelectField,
  RaisedButton
} from 'material-ui'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import IconButton from 'material-ui/IconButton'
import SaveIcon from 'material-ui/svg-icons/content/save'
import InfoIcon from 'material-ui/svg-icons/action/info'
import moment from 'moment'
import { HistoryDetails } from './HistoryDetails'
import Constants from '../../utils/CommonConstants'
import { instance } from '../../lib/api'
import { DeveloperDetails } from '../../components/Common/DeveloperDetails'
import Documents from '../../components/Documents/Documents'
import UploadDocuments from './UploadDocuments'
import DocLink from '../../components/Common/DocLink'
import {
  LOAD_COUNT_DECREMENT,
  LOAD_COUNT_INCREMENT,
  SHOW_SNACKBAR_TOASTR
} from '../../actions/loading'
import EntityTable from '../../components/EntityTable/EntityTable'

const DATE_FORMAT = 'YYYY-MM-DD'
const paymentPurposeMap = {
  ProductActivation: 'Product Activation',
  InvoiceGeneration: 'Invoice Generation'
}

const styleCss = {
  paperWrapper: {
    marginTop: 5,
    marginBottom: 5,
    padding: 5
  }
}
const displayFlexBaseline = {
  maxHeight: '72px'
}
const iconStyle = {
  width: '25px',
  height: '25px',
  verticalAlign: 'middle',
  padding: 0
}
const infoIconStyle = {
  width: 18,
  height: 18
}
const infoTooltipStyles = {
  width: '38vw'
}
const btnStyle = {
  margin: 12
}
const paymentDetailsHeader = {
  display: 'flex',
  justifyContent: 'space-between'
}
const editIconColor = 'rgb(0, 188, 212)'
const infoIconColor = 'red'

export default class PaymentOrderDetails extends Component {
  constructor(props) {
    super(props)
    const {
      order: {
        paymentsDetails: { businessMonth: bm = '', reversalMonth: rm = '' } = {}
      } = {}
    } = props
    this.state = {
      orderDetails: props.order,
      isReadOnly: props.reasonList.length === 0 || props.isSalesRoleOnly,
      documents: [],
      notes: '',
      reasonOfPaymentModeChange: '',
      businessMonth: bm,
      reversalMonth: rm,
      initialPaymentMode:
        props.order.paymentsDetails &&
        props.order.paymentsDetails.modeOfPaymentId
    }
    this.handleCommentsChange = this.handleCommentsChange.bind(this)
    this.handleCommentNotesChange = this.handleCommentNotesChange.bind(this)
    this.uploadDocumentsSuccess = this.uploadDocumentsSuccess.bind(this)
    this.toggelUploadDocuments = this.toggelUploadDocuments.bind(this)
    this.showDeveloperDetails = this.showDeveloperDetails.bind(this)
    this.handleFollowupDate = this.handleFollowupDate.bind(this)
    this.handleFollowupTime = this.handleFollowupTime.bind(this)
    this.handleModalClose = this.handleModalClose.bind(this)
    this.showDocuments = this.showDocuments.bind(this)
    this.showModal = this.showModal.bind(this)
    this.submit = this.submit.bind(this)
    this.handleDuplicateInvoiceGeneration =
      this.handleDuplicateInvoiceGeneration.bind(this)
    this.openDuplicateInvoiceModal = this.openDuplicateInvoiceModal.bind(this)
  }

  handleCommentsChange = (event, index, value) => {
    this.setState({
      _reason: value,
      followupRequired:
        Constants.followupStatus.indexOf(value.nextStatusId) !== -1
          ? Constants.configMsgs.required
          : null
    })
  }

  handlePaymentDetailsChange = (key, value) => {
    let { orderDetails } = this.state
    orderDetails.paymentsDetails[key] = value
    this.setState({
      orderDetails
    })
  }

  handlePaymentModeChange = value =>
    this.setState(state => ({
      ...state,
      orderDetails: {
        ...state.orderDetails,
        paymentsDetails: {
          ...state.orderDetails.paymentsDetails,
          modeOfPaymentId: value
        }
      }
    }))

  handlePaymentModeReasonChange = value =>
    this.setState({ reasonOfPaymentModeChange: value })

  handleRcmOrderDetailsChange = (key, value) => {
    let { orderDetails } = this.state
    orderDetails.rcmOrder[key] = value
    this.setState({
      orderDetails
    })
  }

  handlePaymentDateChange = (key, date) => {
    let { orderDetails } = this.state
    orderDetails.paymentsDetails[key] = moment(date).format(DATE_FORMAT)
    this.setState({
      orderDetails
    })
  }

  handleFollowupDate = (event, date) => {
    this.setState({
      followUpDate: date
    })
  }

  handleFollowupTime = (event, date) => {
    this.setState({
      followUpTime: date
    })
  }

  handleCommentNotesChange = (key, value) => {
    this.setState({
      notes: value
    })
  }

  handleBusinessMonth = month => {
    this.setState({
      businessMonth: month
    })
  }

  handleReversalMonth = month => {
    this.setState({
      reversalMonth: month
    })
  }

  toggelUploadDocuments = () => {
    this.setState({
      isUploadDocuments: !this.state.isUploadDocuments
    })
    if (this.docsUploaded) {
      this.docsUploaded = false
      this.showDocuments()
    }
  }

  handleModalClose = () => {
    this.setState({
      showModal: '',
      isUploadDocuments: false
    })
  }

  showModal = modal => {
    this.setState({
      showModal: modal
    })
  }

  openDeveloperModal = () => {
    this.showModal('developer')
  }

  openDocumentsModal = () => {
    this.showModal('documents')
  }

  openDuplicateInvoiceModal() {
    this.showModal('duplicateInvoice')
  }

  componentWillReceiveProps(nextProps) {
    let orderId = this.props.order.rcmOrder.id
    const { paymentsDetails = {} } = this.props.order
    let { accountId, accountLegalEntityId } = paymentsDetails
    if (nextProps.documents[orderId] && !this.props.documents[orderId]) {
      this.setState(
        {
          documents: nextProps.documents[orderId]
        },
        this.openDocumentsModal
      )
    }
    if (
      nextProps.developerDetails !== this.props.developerDetails &&
      nextProps.developerDetails[accountId]
    ) {
      const legalEntities = nextProps.developerDetails[accountId] || []
      this.setState(
        {
          developer: this.getLegalEntity(legalEntities, accountLegalEntityId)
        },
        this.openDeveloperModal
      )
    }
    if (nextProps.reasonList !== this.props.reasonList) {
      this.setState({
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly
      })
    }
    if (nextProps.order !== this.props.order) {
      const {
        order: {
          paymentsDetails: {
            businessMonth: bm = '',
            reversalMonth: rm = ''
          } = {}
        } = {}
      } = nextProps
      this.setState({
        orderDetails: nextProps.order,
        isReadOnly:
          nextProps.reasonList.length === 0 || nextProps.isSalesRoleOnly,
        documents: [],
        notes: '',
        reasonOfPaymentModeChange: '',
        businessMonth: bm,
        reversalMonth: rm,
        _reason: null,
        followUpDate: undefined,
        followUpTime: undefined,
        followupRequired: null,
        initialPaymentMode:
          nextProps.order.paymentsDetails &&
          nextProps.order.paymentsDetails.modeOfPaymentId
      })
    }
  }

  getLegalEntity = (entityList, entityId) => {
    const entity =
      (entityList.length && entityList.find(le => entityId === le.id)) || {}
    return { ...entity, name: entity.legalName }
  }

  showDeveloperDetails = () => {
    const { paymentsDetails = {} } = this.props.order
    let { accountId, accountLegalEntityId } = paymentsDetails
    const { getDeveloperDetails } = this.props
    if (this.props.developerDetails[accountId]) {
      this.setState(
        {
          developer: this.getLegalEntity(
            this.props.developerDetails[accountId],
            accountLegalEntityId
          )
        },
        this.openDeveloperModal
      )
    } else {
      getDeveloperDetails(accountId)
    }
  }

  showDocuments = () => {
    let { id, paymentsId, caseSubTypeId } = this.props.order.rcmOrder
    const { getOrderDocuments } = this.props
    if (this.props.documents[id]) {
      this.setState(
        {
          documents: this.props.documents[id]
        },
        this.openDocumentsModal
      )
    } else {
      getOrderDocuments(id, paymentsId, 'Payment', caseSubTypeId)
    }
  }

  uploadDocumentsSuccess = () => {
    let { id } = this.props.order.rcmOrder
    this.props.deleteOrderDocuments(id)
    this.docsUploaded = true
  }

  getInvoiceUrl = media => {
    let mediaWithMaxId = null
    if (media && media.length) {
      media.forEach(m => {
        if (!mediaWithMaxId || m.id > mediaWithMaxId.id) {
          mediaWithMaxId = m
        }
      })
    }
    return mediaWithMaxId
  }

  getInvoiceDetails = invoiceList => {
    let result = [],
      { isRcmAdmin, userInfo: { roles = [] } = {} } = this.props || {}
    const isRCMPaymentsAdmin = roles.includes('RCM Payments Admin')

    let taxInvoiceWithMaxId, digislateInvoiceWithMaxId
    if (invoiceList && invoiceList.length) {
      if (isRcmAdmin || isRCMPaymentsAdmin) {
        result = invoiceList
      } else {
        invoiceList.forEach(invoice => {
          if (invoice.type === 'Tax') {
            if (
              invoice.otherAmount !== null &&
              (!taxInvoiceWithMaxId || invoice.id > taxInvoiceWithMaxId.id)
            ) {
              taxInvoiceWithMaxId = invoice
            } else if (
              invoice.digislateAmount !== null &&
              (!digislateInvoiceWithMaxId ||
                invoice.id > digislateInvoiceWithMaxId.id)
            ) {
              digislateInvoiceWithMaxId = invoice
            }
          }
        })
        if (taxInvoiceWithMaxId) {
          //taxInvoiceWithMaxId.invoiceType = 'Tax Invoice';
          result.push(taxInvoiceWithMaxId)
        }
        if (digislateInvoiceWithMaxId) {
          //digislateInvoiceWithMaxId.invoiceType = 'Digislate Invoice';
          result.push(digislateInvoiceWithMaxId)
        }
      }
    }
    return result
  }

  submit = () => {
    if (!this.state.orderDetails.rcmOrder.agentId) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'This Order is Unassigned'
      })
      return
    }
    const reasonID = this.state._reason ? this.state._reason.id : null
    const paymentsDetails = this.state.orderDetails.paymentsDetails || {}
    const rcmOrder = this.state.orderDetails.rcmOrder
    const { statusId } = rcmOrder
    const putData = {
      rcmOrder,
      paymentsDetails
    }
    if (!reasonID) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select a reason.'
      })
      return
    } else if (
      Constants.handoverDateMandatoryReasons.indexOf(reasonID) !== -1 &&
      this.state.orderDetails.paymentsDetails &&
      !this.state.orderDetails.paymentsDetails.rcmHandoverDate
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'RCM Handover Date is mandatory.'
      })
      return
    } else if (
      !this.state.businessMonth.trim().length &&
      Constants.followupStatus.includes(statusId)
    ) {
      //and followup
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Business month is mandatory'
      })
      return
    }

    const followuptime = moment(this.state.followUpDate)
    if (this.state.followUpDate && this.state.followUpTime) {
      const time = moment(this.state.followUpTime)
      followuptime.set({ hour: time.get('hour'), minute: time.get('minute') })
    } else if (
      Constants.followupStatus.indexOf(this.state._reason.nextStatusId) !== -1
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Please select followup Date and Time.'
      })
      return
    }

    //check for followup
    if (Constants.followupStatus.includes(statusId)) {
      putData.rcmOrder.businessMonth = this.state.businessMonth
    }
    if (Constants.followupStatus.includes(statusId)) {
      putData.rcmOrder.reversalMonth = this.state.reversalMonth
    }
    putData.rcmOrder.fupTime = this.state.followUpDate
      ? followuptime.valueOf()
      : null
    putData.reasonId = reasonID ? reasonID : null
    putData.notes = this.state.notes
    const url = Constants.configUrls.PAYMENTS_PUT()
    this.props.putHandler(putData, url)
  }

  handleDuplicateInvoiceGeneration(createDuplicateInvoice) {
    let {
      orderDetails: { paymentsDetails },
      orderDetails
    } = this.state
    paymentsDetails.createDuplicateInvoice = createDuplicateInvoice
    this.setState({ orderDetails }, () => this.submit())
    this.handleModalClose()
  }

  handleSubmit = () => {
    const { caseStatusMap } = this.props
    const {
      orderDetails: { rcmOrder },
      _reason
    } = this.state
    if (
      caseStatusMap[rcmOrder.statusId] == 'Finance Approved' &&
      _reason &&
      _reason.id == '112'
    ) {
      this.openDuplicateInvoiceModal()
    } else this.submit()
  }

  handlePaymentModeSubmit = () => {
    if (
      !this.state.reasonOfPaymentModeChange ||
      this.state.reasonOfPaymentModeChange === ''
    ) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Reason of change field is required'
      })
      return
    }

    if (!this.state.orderDetails.paymentsDetails.id) {
      this.props.dispatch({
        type: SHOW_SNACKBAR_TOASTR,
        message: 'Payment Id field is required'
      })
      return
    }

    const paymentStatus = this.props.paymentStatusMap
    const data = {
      paymentId: this.state.orderDetails.paymentsDetails.id,
      paymentMode: (
        paymentStatus[
          this.state.orderDetails.paymentsDetails.modeOfPaymentId
        ] ||
        paymentStatus[this.state.initialPaymentMode] ||
        ''
      )
        .replaceAll(' ', '_')
        .toUpperCase(),
      reason: this.state.reasonOfPaymentModeChange || ''
    }
    const url = Constants.configUrls.PAYMENTS_MODE_POST()

    this.props.editPaymentModeDetails(data, url)
  }

  businessMonthMenuItems = () => {
    const now = new Date()
    const prev = new Date()
    prev.setMonth(now.getMonth() - 11)
    prev.setDate(1)
    const next = new Date()
    next.setMonth(now.getMonth() + 4)
    next.setDate(1)
    const months = Constants.months
    let result = []
    while (prev.toLocaleString() !== next.toLocaleString()) {
      let month = prev.getMonth()
      result.push(`${months[++month].substring(0, 3)}-${prev.getFullYear()}`)
      prev.setMonth(month)
    }
    return result
  }

  getPaymentStatusTooltip = (rcmOrder, invoiceDetails) => {
    const { pendingFinanceApprovalStatusId = 25 } = Constants
    if (rcmOrder.statusId !== pendingFinanceApprovalStatusId)
      return <React.Fragment />
    if (!invoiceDetails.length) return <React.Fragment />

    const tooltipNode = (
      <p style={{ textAlign: 'left' }}>
        <li>
          Status has been updated in the database, but it is not updated in the
          payment logs.
        </li>
        <li>
          Please login at lookup and click on RCMFix button&#40;On Termsheet
          page&#41; to update the status in rcm.
        </li>
      </p>
    )

    return (
      <IconButton
        aria-label='Info'
        iconStyle={infoIconStyle}
        style={iconStyle}
        className='payment-status-tooltip'
        tooltip={tooltipNode}
        tooltipPosition='bottom-right'
        tooltipStyles={infoTooltipStyles}
      >
        <InfoIcon color={infoIconColor} />
      </IconButton>
    )
  }

  render() {
    const {
      orderDetails,
      notes,
      isUploadDocuments,
      isReadOnly,
      reasonOfPaymentModeChange,
      initialPaymentMode
    } = this.state
    const {
      paymentsDetails = {},
      paymentsDetails: { businessMonth = '', reversalMonth = '' } = {},
      rcmOrder
    } = orderDetails
    const {
      paymentStatusMap,
      userInfo: { roles = [] } = {},
      caseStatusMap = {},
      isRcmAdmin
    } = this.props
    if (!orderDetails.paymentsDetails) {
      orderDetails['paymentsDetails'] = {}
    }

    const isPaymentModeEditable =
      isRcmAdmin &&
      paymentsDetails.id &&
      (rcmOrder.statusId === Constants.newFollowupStatusIds[0] ||
        rcmOrder.statusId === Constants.pendingFinanceApprovalStatusId)

    const invoiceDetails =
      this.getInvoiceDetails(paymentsDetails.invoiceDetails) || []
    const businessMonths = this.businessMonthMenuItems()
    let orderType
    switch (rcmOrder.caseSubTypeId) {
      case Constants.CaseSubTypeMap.BROKER.PAYMENTS:
        orderType = 'Broker'
        break
      case Constants.CaseSubTypeMap.DEVELOPER.PAYMENTS:
        orderType = 'Developer'
        break
      case Constants.CaseSubTypeMap.MAKAAN.PAYMENTS:
        orderType = 'Makaan'
        break
      default:
        orderType = false
    }
    const creditNote =
      paymentsDetails.creditNoteDetails &&
      paymentsDetails.creditNoteDetails.length &&
      paymentsDetails.creditNoteDetails.map(note => (
        <DocLink key={note.mediaLink} url={note.mediaLink} />
      ))
    return (
      <div>
        <section className='order-rcm-info clearfix'>
          {orderType && (
            <div className='col-xs-12 ta-c'>{orderType} Payment</div>
          )}
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              <strong>Payment ID: </strong>
              {rcmOrder ? rcmOrder.paymentsId : '----------'}
            </p>
            <p className='sm-info'>
              ({this.props.caseStatusMap[rcmOrder.statusId]})
              {this.getPaymentStatusTooltip(rcmOrder, invoiceDetails)}
            </p>
            {rcmOrder.sourcePaymentCase && (
              <p className='sm-info'>
                <label>Source Payment Id: </label>
                <Link
                  to={`/detail/${rcmOrder.sourcePaymentCase}`}
                  target='_blank'
                >
                  {paymentsDetails.sourcePaymentId}
                </Link>
              </p>
            )}
          </div>
          <div className='col-xs-6'>
            <p className='lg-info'>
              {paymentsDetails.ramUser
                ? paymentsDetails.ramUser.fullName
                : '----------'}
            </p>
          </div>
          <div className='col-xs-6 col-md-3'>
            <p className='lg-info'>
              {paymentsDetails.ramUser &&
              paymentsDetails.ramUser.contactNumbers &&
              paymentsDetails.ramUser.contactNumbers.length
                ? paymentsDetails.ramUser.contactNumbers[0].contactNumber
                : '----------'}
            </p>
            <p className='sm-info'>
              {orderDetails.cityName ? orderDetails.cityName : '----------'}
            </p>
          </div>
        </section>
        <div className='container-fluid' style={{ paddingBottom: '60px' }}>
          <Paper zDepth={1} style={styleCss.paperWrapper}>
            <div className='container-fluid'>
              <div className='row box-wrap'>
                <p>
                  Opportunity Details{' '}
                  <span className='static-field pull-right'>
                    <label>Term Sheet Number: </label>{' '}
                    <Link
                      to={`/detail/${rcmOrder.termsheetCaseId}`}
                      target='_blank'
                    >
                      {paymentsDetails.termsheetNumber}
                    </Link>
                  </span>
                </p>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Id'
                    floatingLabelText='Opportunity Id'
                    disabled
                    type='number'
                    value={paymentsDetails.opportunityId || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Opportunity Name'
                    floatingLabelText='Opportunity Name'
                    disabled
                    value={paymentsDetails.opportunityName || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Deal Amount'
                    floatingLabelText='Deal Amount'
                    disabled
                    value={
                      (paymentsDetails.opportunityDetails &&
                        paymentsDetails.opportunityDetails.dealValue) ||
                      ''
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Termsheet Number'
                    floatingLabelText='Termsheet Number'
                    disabled
                    value={paymentsDetails.termsheetNumber || ''}
                  />
                </div>
              </div>
              <div className='row box-wrap'>
                <div style={paymentDetailsHeader}>
                  <p>Payment Details</p>
                  {isPaymentModeEditable &&
                    paymentsDetails.modeOfPaymentId !== initialPaymentMode && (
                      <div>
                        <IconButton
                          aria-label='save payment mode'
                          style={iconStyle}
                          onClick={this.handlePaymentModeSubmit}
                        >
                          <SaveIcon color={editIconColor} />
                        </IconButton>
                      </div>
                    )}
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Milestone Id'
                    floatingLabelText='Milestone Id'
                    disabled
                    value={paymentsDetails.milestoneId || ''}
                  />
                </div>
                <div
                  style={displayFlexBaseline}
                  className='col-xs-6 col-md-4 col-lg-3'
                >
                  <SelectField
                    disabled={!isPaymentModeEditable}
                    hintText='Payment Mode'
                    floatingLabelText='Payment Mode'
                    value={paymentsDetails.modeOfPaymentId}
                    onChange={(_1, _2, value) =>
                      this.handlePaymentModeChange(value)
                    }
                  >
                    {paymentStatusMap &&
                      Object.keys(paymentStatusMap)
                        .map(Number)
                        .map(key => (
                          <MenuItem
                            key={paymentStatusMap[key]}
                            value={key}
                            primaryText={paymentStatusMap[key]}
                          />
                        ))}
                  </SelectField>
                </div>
                {paymentsDetails.modeOfPaymentId !== initialPaymentMode && (
                  <div className='col-xs-6 col-md-4 col-lg-3'>
                    <TextField
                      hintText='Reason for change'
                      floatingLabelText='Reason for change'
                      multiLine
                      required
                      autoFocus
                      onChange={(event, value) =>
                        this.handlePaymentModeReasonChange(value)
                      }
                      value={reasonOfPaymentModeChange || ''}
                    />
                  </div>
                )}
                {paymentsDetails && paymentsDetails.modeOfPaymentId == 7 ? (
                  <div className='col-xs-6 col-md-4 col-lg-3'>
                    <TextField
                      hintText='Payment Purpose'
                      floatingLabelText='Payment Purpose'
                      disabled
                      value={
                        paymentPurposeMap[paymentsDetails.paymentPurpose] || ''
                      }
                    />
                  </div>
                ) : null}
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Amount'
                    floatingLabelText='Amount'
                    type='number'
                    disabled={isReadOnly}
                    value={paymentsDetails.amount || ''}
                    onChange={(event, value) =>
                      this.handlePaymentDetailsChange('amount', value)
                    }
                  />
                </div>
                {typeof paymentsDetails.refundedAmount !== 'undefined' && (
                  <div className='col-xs-6 col-md-4 col-lg-3'>
                    <TextField
                      hintText='Refunded Amount'
                      floatingLabelText='Refunded Amount'
                      type='number'
                      disabled={isReadOnly}
                      value={paymentsDetails.refundedAmount || ''}
                      onChange={(event, value) =>
                        this.handlePaymentDetailsChange('refundedAmount', value)
                      }
                    />
                  </div>
                )}
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='GST'
                    floatingLabelText='GST'
                    type='number'
                    disabled
                    value={paymentsDetails.gst || ''}
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='TDS Deducted'
                    floatingLabelText='TDS Deducted'
                    type='number'
                    disabled={isReadOnly}
                    value={paymentsDetails.tdsDeducted || ''}
                    onChange={(event, value) =>
                      this.handlePaymentDetailsChange('tdsDeducted', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Instrument Number'
                    floatingLabelText='Instrument Number'
                    disabled={isReadOnly}
                    value={paymentsDetails.referenceNumber || ''}
                    onChange={(event, value) =>
                      this.handlePaymentDetailsChange('referenceNumber', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Bank'
                    floatingLabelText='Bank'
                    disabled={isReadOnly}
                    value={paymentsDetails.bankName}
                    onChange={(event, value) =>
                      this.handlePaymentDetailsChange('bankName', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='Payment Due Date'
                    floatingLabelText='Payment Due Date'
                    disabled={isReadOnly}
                    value={
                      paymentsDetails.paymentDueDate
                        ? moment(paymentsDetails.paymentDueDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('paymentDueDate', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='Expected Deposit Date'
                    floatingLabelText='Expected Deposit Date'
                    disabled={isReadOnly}
                    value={
                      paymentsDetails.expectedDepositDate
                        ? moment(paymentsDetails.expectedDepositDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('expectedDepositDate', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='Payment Received Date'
                    floatingLabelText='Payment Received Date'
                    disabled={isReadOnly}
                    value={
                      paymentsDetails.paymentReceivedDate
                        ? moment(paymentsDetails.paymentReceivedDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('paymentReceivedDate', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <TextField
                    hintText='Handover To'
                    floatingLabelText='Handover To'
                    disabled={isReadOnly}
                    value={rcmOrder.handoverTo}
                    onChange={(event, value) =>
                      this.handleRcmOrderDetailsChange('handoverTo', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='RCM Handover Date'
                    floatingLabelText='RCM Handover Date'
                    disabled={isReadOnly}
                    value={
                      paymentsDetails.rcmHandoverDate
                        ? moment(paymentsDetails.rcmHandoverDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('rcmHandoverDate', value)
                    }
                  />
                </div>
                {Constants.followupStatus.includes(rcmOrder.statusId) && (
                  <div className='col-xs-6 col-md-4 col-lg-3'>
                    <SelectField
                      hintText='Business month'
                      floatingLabelText='Business Month'
                      value={this.state.businessMonth}
                      onChange={(_, __, value) =>
                        this.handleBusinessMonth(value)
                      }
                    >
                      {businessMonths.map(month => (
                        <MenuItem
                          primaryText={month}
                          value={month}
                          key={month}
                        />
                      ))}
                    </SelectField>
                  </div>
                )}
                {Constants.followupStatus.includes(rcmOrder.statusId) && (
                  <div className='col-xs-6 col-md-4 col-lg-3'>
                    <SelectField
                      hintText='Reversal month'
                      floatingLabelText='Reversal Month'
                      value={this.state.reversalMonth}
                      onChange={(_, __, value) =>
                        this.handleReversalMonth(value)
                      }
                    >
                      {businessMonths.map(month => (
                        <MenuItem
                          primaryText={month}
                          value={month}
                          key={month}
                        />
                      ))}
                    </SelectField>
                  </div>
                )}
              </div>
              <div className='row box-wrap'>
                <p>Finance Details</p>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='Deposit Date'
                    floatingLabelText='Deposit Date'
                    disabled={
                      isReadOnly ||
                      (paymentsDetails.isYesBankPayment &&
                        paymentsDetails.actualDepositDate)
                    }
                    value={
                      paymentsDetails.actualDepositDate
                        ? moment(paymentsDetails.actualDepositDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('actualDepositDate', value)
                    }
                  />
                </div>
                <div className='col-xs-6 col-md-4 col-lg-3'>
                  <DatePicker
                    hintText='Clearance Date'
                    floatingLabelText='Clearance Date'
                    disabled={
                      isReadOnly ||
                      (paymentsDetails.isYesBankPayment &&
                        paymentsDetails.clearanceDate)
                    }
                    value={
                      paymentsDetails.clearanceDate
                        ? moment(paymentsDetails.clearanceDate).toDate()
                        : null
                    }
                    onChange={(event, value) =>
                      this.handlePaymentDateChange('clearanceDate', value)
                    }
                  />
                </div>
              </div>
              {invoiceDetails.length > 0 && (
                <div className='row box-wrap'>
                  <p>Invoice Details</p>
                  <Table onRowSelection={this.handleRowSelection}>
                    <TableHeader
                      displaySelectAll={false}
                      adjustForCheckbox={false}
                    >
                      <TableRow>
                        <TableHeaderColumn>Invoice Number</TableHeaderColumn>
                        <TableHeaderColumn>Date</TableHeaderColumn>
                        <TableHeaderColumn>Amount</TableHeaderColumn>
                        <TableHeaderColumn>Type</TableHeaderColumn>
                        <TableHeaderColumn>Invoice Link</TableHeaderColumn>
                        <TableHeaderColumn>Action</TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                      {Array.isArray(invoiceDetails)
                        ? [...invoiceDetails]
                            .sort((a, b) => a.id - b.id)
                            .map((invoice, index) => {
                              const mediaWithMaxId = this.getInvoiceUrl(
                                invoice.media
                              )
                              return (
                                <TableRow key={index}>
                                  <TableRowColumn>
                                    {invoice.invoiceNumber}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {moment(invoice.createdAt).format(
                                      Constants.DATE_FORMAT
                                    )}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {invoice.otherAmount ||
                                      invoice.digislateAmount}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {invoice.type === 'Tax'
                                      ? 'Tax Invoice'
                                      : 'Digislate Invoice'}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {mediaWithMaxId && (
                                      <DocLink
                                        url={mediaWithMaxId.absoluteUrl}
                                      />
                                    )}
                                  </TableRowColumn>
                                  <TableRowColumn>
                                    {mediaWithMaxId && (
                                      <React.Fragment>
                                        <FlatButton
                                          className='sm-info'
                                          label='Regenerate'
                                          disabled={isReadOnly}
                                          primary={true}
                                          onClick={() =>
                                            this.props.deleteOrderInvoice(
                                              invoice.id,
                                              true
                                            )
                                          }
                                        />
                                        <FlatButton
                                          className='sm-info'
                                          label='Cancel'
                                          disabled={isReadOnly}
                                          primary={true}
                                          onClick={() =>
                                            this.props.deleteOrderInvoice(
                                              invoice.id,
                                              false
                                            )
                                          }
                                        />
                                      </React.Fragment>
                                    )}
                                  </TableRowColumn>
                                </TableRow>
                              )
                            })
                        : null}
                    </TableBody>
                  </Table>
                </div>
              )}
              {creditNote && (
                <p>
                  <label>Credit Note:</label> {creditNote}
                </p>
              )}
              <div className='row box-wrap box-grey'>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Comment</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <SelectField
                      value={this.state._reason}
                      disabled={
                        isReadOnly ||
                        (caseStatusMap[rcmOrder.statusId].toLowerCase() ==
                          Constants.rejectedAfterApproval.toLowerCase() &&
                          !roles.includes(Constants.roles.rcmPaymentsAdmin))
                      }
                      onChange={this.handleCommentsChange}
                      hintText={'Select Comment'}
                      fullWidth
                    >
                      {this.props.reasonList.map(reason => {
                        return (
                          <MenuItem
                            value={reason}
                            key={reason.id}
                            primaryText={reason.label}
                          />
                        )
                      })}
                    </SelectField>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Followup Date</label>
                  </div>
                  <div className='row col-md-9 col-xs-8'>
                    <div className='col-xs-6 col-md-4'>
                      <DatePicker
                        hintText='Followup Date'
                        value={this.state.followUpDate}
                        minDate={moment().toDate()}
                        disabled={isReadOnly}
                        onChange={this.handleFollowupDate}
                        errorText={
                          this.state.followUpDate
                            ? null
                            : this.state.followupRequired
                        }
                      />
                    </div>
                    <div className='col-xs-6 col-md-4'>
                      <TimePicker
                        format='ampm'
                        minutesStep={5}
                        hintText='Followup Time'
                        disabled={isReadOnly}
                        errorText={
                          this.state.followUpTime
                            ? null
                            : this.state.followupRequired
                        }
                        onChange={this.handleFollowupTime}
                        value={this.state.followUpTime}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-xs-12'>
                  <div className='col-md-3 col-xs-4'>
                    <label className='line-height-50'>Notes</label>
                  </div>
                  <div className='col-md-9 col-xs-8'>
                    <TextField
                      hintText='Notes'
                      disabled={isReadOnly}
                      value={notes}
                      onChange={this.handleCommentNotesChange}
                      fullWidth
                    />
                  </div>
                </div>
                <div className='col-xs-12 text-center'>
                  <RaisedButton
                    label='Submit'
                    primary
                    disabled={isReadOnly}
                    style={btnStyle}
                    onClick={this.handleSubmit}
                  />
                </div>
              </div>
              <section className='footer-fixed-actions'>
                <div
                  className='footer-action-item'
                  onClick={this.showDeveloperDetails}
                >
                  Developer Details
                </div>
                <div
                  className='footer-action-item'
                  onClick={this.showDocuments}
                >
                  Documents
                </div>
                <div
                  className='footer-action-item'
                  onClick={() => this.showModal('history')}
                >
                  History
                </div>
              </section>
            </div>
          </Paper>
          <Dialog
            title='Developer Details'
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'developer'}
            onRequestClose={this.handleModalClose}
          >
            {this.state.developer ? (
              <DeveloperDetails details={this.state.developer} />
            ) : (
              <p>Developer Details not available.</p>
            )}
          </Dialog>
          <Dialog
            title='Documents Details'
            actions={[
              <FlatButton
                label={isUploadDocuments ? 'Done Upload' : 'Upload Documents'}
                primary
                disabled={isReadOnly}
                onClick={this.toggelUploadDocuments}
              />,
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            ]}
            modal={false}
            open={this.state.showModal === 'documents'}
            autoScrollBodyContent
            onRequestClose={this.handleModalClose}
          >
            {isUploadDocuments ? (
              <UploadDocuments
                orderType={rcmOrder.caseSubTypeId}
                orderId={rcmOrder.paymentsId}
                onUploadSuccess={this.uploadDocumentsSuccess}
                objectType={'Payment'}
                docTypes={Constants.documentTypes.PAYMENTS}
                dispatch={this.props.dispatch}
              />
            ) : this.state.documents &&
              Object.keys(this.state.documents).length ? (
              <Documents documents={this.state.documents} />
            ) : (
              <p>Documents Details not available.</p>
            )}
          </Dialog>

          <Dialog
            title='History Details'
            autoScrollBodyContent
            actions={
              <FlatButton
                label='Close'
                primary
                onClick={this.handleModalClose}
              />
            }
            modal={false}
            open={this.state.showModal === 'history'}
            onRequestClose={this.handleModalClose}
          >
            {rcmOrder.actions && rcmOrder.actions.length ? (
              <HistoryDetails
                caseActions={rcmOrder.actions}
                caseStatusMap={this.props.caseStatusMap}
              />
            ) : (
              <p>History Details not available.</p>
            )}
          </Dialog>
          <Dialog
            actions={[
              <FlatButton
                label={'Yes'}
                primary
                disabled={isReadOnly}
                onClick={() => this.handleDuplicateInvoiceGeneration(true)}
              />,
              <FlatButton
                label='No'
                primary
                onClick={() => this.handleDuplicateInvoiceGeneration(false)}
              />
            ]}
            modal={false}
            open={this.state.showModal === 'duplicateInvoice'}
            onRequestClose={this.handleModalClose}
          >
            <p>Do you want to create a new invoice ?</p>
          </Dialog>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/OrderDetails/PaymentOrderDetails.js
 **/